import { render, staticRenderFns } from "./ApprovalImageGalleryReject.vue?vue&type=template&id=ec478faa&"
import script from "./ApprovalImageGalleryReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalImageGalleryReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports